import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { map, of } from 'rxjs';
import { ConfirmLeaveDialog, ConfirmLeaveDialogData } from '../../../shared/components/confirm-leave-dialog/confirm-leave-dialog';

/** Any component that wants unsaved-changes protection implements this interface. */
export interface HasUnsavedChanges {
  hasUnsavedChanges(): boolean;
  unsavedChangesMessage?(): ConfirmLeaveDialogData;
}

/**
 * CanDeactivate guard that opens a confirmation dialog when the component
 * reports unsaved changes. Works with any component that implements
 * `HasUnsavedChanges`.
 */
export const unsavedChangesGuard: CanDeactivateFn<HasUnsavedChanges> = (component) => {
  if (!component.hasUnsavedChanges()) {
    return true;
  }

  const dialog = inject(MatDialog);
  const data: ConfirmLeaveDialogData = component.unsavedChangesMessage?.() ?? {};

  const ref = dialog.open(ConfirmLeaveDialog, {
    width: '420px',
    disableClose: true,
    data,
  });

  return ref.afterClosed().pipe(map(result => result === true));
};
